export const TOAST_MESSAGE_TYPES = {
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
};

export const SHOW_TOAST = "@SnackBar/SHOW_TOAST";
export const HIDE_TOAST = "@SnackBar/HIDE_TOAST";

export const MATHJAX_SCRIPT =
  "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=AM_HTMLorMML";

export const MODAL_TEXT = {
  SUBMIT: "Are you sure you want to Submit?",
  GO_BACK: "Are you sure you need to go back?\n Your changes will be lost",
};

export const toastMessages = {
  noFilterSelected: "Please selecte any filter!",
  feeReadOnly:
    "You can't edit this Fee as Some(or All) of its Payments are already done",
};

export const SIDEBAR_MENU_ITEMS = {
  dashboard: {
    key: "dashboard",
    pathname: "/dashboard",
    name: "Dashboard",
  },
  fee_collection: {
    key: "student_list",
    pathname: "/student_list",
    name: "Payments",
  },
  fee_list: {
    key: "fee_bundle/list",
    pathname: "/fee_bundle/list",
    name: "Fee Bundles",
  },
  fee_report: {
    key: "report",
    pathname: "/report",
    name: "Reports",
  },
  fee_accounts: {
    key: "fee_bundle/fee_accounts",
    pathname: "/fee_bundle/fee_accounts",
    name: "Fee Accounts",
  },
  gst: {
    key: "fee_bundle/gst",
    pathname: "/fee_bundle/gst",
    name: "GST",
  },
  tool: {
    key: "tool",
    pathname: "/tool",
    name: "Export",
  },
  classrooms: {
    key: "classrooms",
    pathname: "/institute/classrooms",
    name: "Classrooms",
  },
  my_institute: {
    key: "my_institute",
    pathname: "/institute/settings",
    name: "My Institute",
  },
  institutes_tracks: {
    key: "institutes_tags",
    pathname: "/institute/institutes_tags",
    name: "Tags",
  }
};
